import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tag__left-icon" }
const _hoisted_2 = { class: "tag__sign" }
const _hoisted_3 = { class: "tag__right-icon" }

import { withDefaults } from "vue";
import { TirPmTagStateEnum, TirPmTagSizeEnum } from "./enums";


export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmTag',
  props: {
    variant: {},
    size: {},
    isRounded: { type: Boolean },
    isBordered: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tag", {
      'tag--rounded': props.isRounded,
      'tag--middle': props.size == _unref(TirPmTagSizeEnum).Middle,
      'tag--small': props.size == _unref(TirPmTagSizeEnum).Small,
      'tag--bordered': props.isBordered,
      'tag--disabled': props.variant == _unref(TirPmTagStateEnum).DisabledState,
      'tag--selected': props.variant == _unref(TirPmTagStateEnum).SelectedState,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "leftIcon")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "rightIcon")
    ])
  ], 2))
}
}

})